import { RefObject, useEffect } from 'react';

const CONTROL_SELECTOR = 'a[href], button, input, select, textarea, [tabindex]';

// A control that does not read useRowTabIndex stays in the Tab order in each
// row, so Tab stops on it once per row. This check finds such a control when
// a row mounts and each time the row loses the Tab stop. It runs only in
// development.
const useReportControlInTabOrder = (
    rowRef: RefObject<HTMLElement>,
    rowIsTabStop: boolean,
) => {
    useEffect(() => {
        if (process.env.NODE_ENV === 'production' || rowIsTabStop) {
            return;
        }

        const control = Array.from(
            rowRef.current?.querySelectorAll<HTMLElement>(CONTROL_SELECTOR) ??
                [],
        ).find(
            (element) => element.tabIndex >= 0 && !element.matches(':disabled'),
        );
        if (control) {
            console.error(
                'A control in a list row is in the Tab order, but the row does not hold the Tab stop. Build it on BaseButton, ContextMenu or Popover, or give it tabIndex={useRowTabIndex()}.',
                control,
            );
        }
    }, [rowRef, rowIsTabStop]);
};

export default useReportControlInTabOrder;
